import { Cache } from "~/types/cache";
import { useMessages } from "~/store/messages";

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return;
  if (to.path === from.path) return;
  document.title = `Nexprint`;

  const messagesStore = useMessages();
  messagesStore.getMessages({
    pageNo: 1,
    pageSize: 10,
  });
  messagesStore.getMessagesState();
});
